import * as actionTypes from './actionTypes';
import { LogType } from '../../../types';
import {
  LogsAddActionType,
  LogsUpdateActionType,
  LogsRemoveActionType,
  LogsClearActionType,
} from './types';

const add = (payload: LogType[]): LogsAddActionType => ({
  type: actionTypes.ADD,
  payload,
});

const update = (payload: LogType[]): LogsUpdateActionType => ({
  type: actionTypes.UPDATE,
  payload,
});

const remove = (payload: string | string[]): LogsRemoveActionType => ({
  type: actionTypes.REMOVE,
  payload,
});

const clear = (): LogsClearActionType => ({
  type: actionTypes.CLEAR,
});

export {
  add,
  update,
  remove,
  clear,
};
